<script lang="ts">
import { useUserStore } from "~/store/index"

export default {
    setup() {
        // https://vueuse.org/integrations/useCookies/
        const access_token = useCookie<string>("access_token")
        return {
            access_token,
        }
    },
    data() {
        return {
            email: null,
            password: null,
            visible: false,
            loading: false,
        }
    },
    methods: {
        async login() {
            try {
                this.loading = true
                const res = await this.$api.setRequest({
                    url: "login",
                    method: "POST",
                    body: { email: this.email, password: this.password },
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                    },
                }, true)

                this.access_token = res.access_token
                useUserStore().fetchUser({ value: this.access_token })
                    .then(() => this.$router.push("/")) /* REDIRECTION A LA CONNEXION */
            }
            catch (e) {
                this.loading = false
                this.$showToaster({ title: "Échec de la connexion", text: `La connexion a échoué, veuillez vérifier votre identifiant ou mot de passe.`, color: "error", icon: "mdi-alert-circle", timer: -1 })
                return e
            }
        },
    },
}
</script>

<template>
    <v-form validate-on="submit lazy" @submit.prevent="login">
        <div class="text-subtitle-1 text-medium-emphasis">
            E-mail
        </div>
        <v-text-field
            v-model="email"
            density="compact"
            placeholder="Entrer votre identifiant"
            prepend-inner-icon="mdi-email-outline"
            variant="outlined"
        />

        <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
            Mot de passe
        </div>

        <v-text-field
            v-model="password"
            :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
            :type="visible ? 'text' : 'password'"
            density="compact"
            placeholder="Entrer votre mot de passe"
            prepend-inner-icon="mdi-lock-outline"
            variant="outlined"
            :hide-details="true"
            @click:append-inner="visible = !visible"
        />
        <v-btn variant="text" class="px-0 text-caption text-decoration-none text-blue" @click="$router.push('/connexion/mot-de-passe-oublie')">
            Mot de passe oublié ?
        </v-btn>

        <v-btn
            block class="my-4"
            color="primary" size="large"
            type="submit"
            :loading="loading"
        >
            Se connecter
        </v-btn>

        <!--        <v-btn -->
        <!--            block class="my-4" -->
        <!--            color="primary" size="large" -->
        <!--            variant="tonal" -->
        <!--            @click="$router.push('/')" -->
        <!--        > -->
        <!--            Retourner à l'accueil -->
        <!--        </v-btn> -->
    </v-form>
</template>
